import { render, staticRenderFns } from "./QuaternaryTitle.vue?vue&type=template&id=b41f3066&"
import script from "./QuaternaryTitle.vue?vue&type=script&lang=js&"
export * from "./QuaternaryTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports